var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatsDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2C3.34315 2 2 3.34315 2 5V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V5C22 3.34315 20.6569 2 19 2H5ZM13.4118 15.8333C12.9515 15.8333 12.5784 15.4602 12.5784 15C12.5784 14.5398 12.9515 14.1667 13.4118 14.1667H15.9989L12.8491 10.9928L12.8464 10.9901C12.7581 10.9003 12.621 10.9003 12.5328 10.9901L10.8486 12.7031C10.1073 13.4571 8.89943 13.4571 8.15812 12.7031L8.14238 12.6871L5.37518 9.55139C5.07066 9.20632 5.10353 8.67971 5.44861 8.37518C5.79368 8.07066 6.32029 8.10353 6.62482 8.44861L9.35699 11.5446C9.44531 11.6242 9.57531 11.6209 9.66013 11.5346L11.3444 9.82159C12.0852 9.06815 13.2918 9.06762 14.0333 9.82001L14.0348 9.82159L17.1667 12.9773V10.4058C17.1667 9.9456 17.5398 9.5725 18 9.5725C18.4602 9.5725 18.8333 9.9456 18.8333 10.4058V15C18.8333 15.4602 18.4602 15.8333 18 15.8333H13.4118Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatsDown);
export default __webpack_public_path__ + "static/media/stats-down.8065ecab05392d508091b935428767a4.svg";
export { ForwardRef as ReactComponent };